import { STANDARD_RESUME } from '@components/userDocuments/editDocument/editResume/EditSpace/EditorPane/Pad/ExpertTips/Shared/expertTipsEnums';
import templateDefaultProps from '../../constants/templateDefaultProps';
import getDefaultSectionTitle from './getDefaultSectionTitle';
import getCustomTemplateColorPalette from '../../utility/universityPolicies/getCustomTemplateColorPalette';
import { getDefaultSections } from './getDefaultSections';

export const generateSectionObjectArray = ({
  sectionsArray,
  toExport,
  warning,
  selectedPlan,
  universityPlan,
}) => {
  return sectionsArray.map((sectionKey) => {
    const title = getDefaultSectionTitle({
      selectedPlan,
      universityPlan,
      sectionKey,
    });
    return sectionKey === 'personalInfo'
      ? {
          title,
          toExport: {
            full_name: false,
            tagline: false,
            email: false,
            phone_number: false,
            personal_link: true,
            address: false,
            objective: false,
          },
          warning: false,
          defaultSection: true,
          sectionKey,
        }
      : {
          title,
          toExport,
          warning,
          sectionKey,
        };
  });
};

export default ({
  isSmallScreen = false,
  selectedPlan = null,
  universityPlan = null,
}) => {
  const userPreferences = {
    fieldOfStudy: STANDARD_RESUME,
    veteranFieldOfStudy: STANDARD_RESUME,
    layout: {
      previewPad: !isSmallScreen,
      galleryPad: false,
      leftPane: true,
      menuBar: true,
      galleryPadFullScreen: true,
      tetraScan: false,
      tipsPad: false,
      veteranTips: false,
      linkedInOptimizer: false,
      contentGeneration: false,
      questionsGenerator: false,
      aiCareerPath: false,
    },
    colorPalette: getCustomTemplateColorPalette({
      universityPlan,
    }),
    templateProperty: {
      default: { ...templateDefaultProps.RESUME },
      updated: {},
    },
    leftPane: {
      activeElement: {
        title: 'Personal Info',
        index: 0,
        sectionKey: 'personalInfo',
      },
      used: getDefaultSections(selectedPlan, universityPlan)?.used,
      unUsed: getDefaultSections(selectedPlan, universityPlan)?.unUsed,
    },
    showIcons: {
      personalLinks: false,
    },
    showTexts: {
      personalLinks: false,
    },
    showLinks: {
      personalLinks: true,
    },
    covid19vaccinated: 'not',
  };

  return userPreferences;
};
